import React from "react";
export const LoadingView = () => {
    return (<p className="load">Trwa ładowanie...</p>)
}
